import React from 'react';
import { Link } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import VerifiedIcon from '@mui/icons-material/Verified';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import PublicIcon from '@mui/icons-material/Public';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';

const IMG = {
  surgery: 'https://images.unsplash.com/photo-1551076805-e1869033e561?q=80&w=2532&auto=format&fit=crop',
};

const TRUST_BADGES = [
  { icon: <VerifiedIcon fontSize="large" />, title: 'CE Certified', desc: 'All products meet international CE standards' },
  { icon: <WorkspacePremiumIcon fontSize="large" />, title: 'FDA Approved', desc: 'FDA approval certification on all products' },
  { icon: <PublicIcon fontSize="large" />, title: 'Africa-Wide', desc: 'Exporting across sub-Saharan Africa' },
  { icon: <HistoryEduIcon fontSize="large" />, title: '10+ Years', desc: 'A decade of trusted medical supply' },
];

const HomeAbout: React.FC = () => (
  <section className="py-12 sm:py-20 bg-white">
    <div className="container-main grid lg:grid-cols-2 gap-10 sm:gap-16 items-stretch">
      <div className="relative h-full min-h-[280px] sm:min-h-[360px] lg:min-h-[500px]">
        <img src={IMG.surgery} alt="Surgical Team Operating" className="w-full h-full min-h-[280px] sm:min-h-[360px] lg:min-h-[500px] rounded-2xl sm:rounded-3xl object-cover shadow-xl" />
        <div className="absolute bottom-2 right-2 sm:-bottom-5 sm:-right-5 bg-primary text-white px-5 py-4 sm:px-8 sm:py-6 rounded-2xl sm:rounded-3xl shadow-2xl">
          <div className="text-2xl sm:text-4xl font-extrabold mb-0.5 sm:mb-1">10+</div>
          <div className="text-white/70 text-xs sm:text-sm uppercase tracking-wider font-semibold">Years of Service</div>
        </div>
      </div>
      <div className="min-w-0">
        <span className="section-label">About Manlab</span>
        <h2 className="section-heading mb-4 sm:mb-6">Zimbabwe's Most Trusted Medical Equipment Supplier</h2>
        <p className="text-gray-600 text-sm sm:text-base leading-relaxed mb-4">
          Manlab Medicals Incorporated was established over 10 years ago with offices in Zimbabwe,
          servicing the sub-Saharan and African market with CE Certified, FDA Approved medical equipment.
        </p>
        <p className="text-gray-600 text-sm sm:text-base leading-relaxed mb-6 sm:mb-8">
          We supply surgical, dental, electrosurgical, diagnostics, and laboratory equipment to hospitals
          and laboratories across Zimbabwe and export throughout Africa.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-6 sm:mb-8">
          {TRUST_BADGES.map(item => (
            <div key={item.title} className="flex items-start gap-3">
              <div className="text-primary mt-0.5">{item.icon}</div>
              <div>
                <div className="font-bold text-primary text-sm">{item.title}</div>
                <div className="text-gray-500 text-xs">{item.desc}</div>
              </div>
            </div>
          ))}
        </div>
        <Link to="/about" className="inline-flex items-center gap-2 border-2 border-primary text-primary px-7 py-3 rounded-full font-semibold hover:bg-primary hover:text-white transition-colors">
          Learn More <ArrowForwardIcon />
        </Link>
      </div>
    </div>
  </section>
);

export default HomeAbout;
